/**
 * failedRecoveryModal.compoent.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

import { Dialog } from "../components/dialog.component";

import { groupServiceFactory } from "../services/group.service";

interface FailedRecoveryDialogProps {
  open: boolean,
  groupID: string,
  onClose(): void
}
export function FailedRecoveryDialog(props: FailedRecoveryDialogProps): React.ReactElement<any, any> {
  const groupService = groupServiceFactory();
  const [deleting, setDeleting] = React.useState<boolean>(false);

  async function doClearGroup () {
    try {
      setDeleting(true);
      props.groupID && await groupService.clearGroup(props.groupID);
      props.onClose();
    } catch (err) {
      console.error("Couldn't delete group:", err);
    } finally {
      setDeleting(false);
    }
  }

  return <Dialog
      classNames="failed-recover-modal"
      loading={deleting}
      open={props.open}
      title="Failed Automatic Recovery"
      onConfirm={doClearGroup}
      onClose={props.onClose}
      confirmText="Clear Faulty Data">
    <p>
      This device lags too far behind the rest of the group to
      be able to recover and catch up automatically. You or another
      member of the group can remove this device from the group using
      another device. Once removed from the group for all members' devices,
      it can be re-added to the group. This device is identified as:
    </p>
    <p><strong>{groupService.deviceDisplay}</strong></p>
    <p>Also, we need to clear this group's data from this device.
      Can we proceed?
    </p>
  </Dialog>;
}
